var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaunaRoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.323,
    height: 15.848,
    viewBox: "0 0 13.323 15.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M1164.2,395.377c-.25-.485-.5-.98-.743-1.459-.2-.4-.412-.814-.62-1.22-.043-.083-.084-.168-.124-.25a4.772,4.772,0,0,0-.4-.716,2.17,2.17,0,0,0-1.81-.89c-.379-.008-.783-.011-1.272-.011-.347,0-.7,0-1.042,0l-.641,0a.369.369,0,0,1-.352-.2c-.115-.194-.239-.388-.358-.576l-.13-.205c-.107-.17-.214-.343-.318-.51-.234-.38-.477-.772-.733-1.144a1.315,1.315,0,0,0-1.065-.6,1.126,1.126,0,0,0-.739.277,1.574,1.574,0,0,0-.384.536c-.329.72-.652,1.458-.964,2.171l-.352.8q-.1.219-.194.437c-.141.316-.287.643-.422.967a.508.508,0,0,0,.252.678.576.576,0,0,0,.232.051.529.529,0,0,0,.472-.315c.02-.039.037-.08.055-.123l.023-.053.244-.556q.466-1.06.933-2.12c.015-.034.032-.064.051-.1l.033-.061.1-.19.124.176.04.057c.026.034.047.065.067.1l.239.376c.506.795,1.03,1.616,1.543,2.426.042.067.064.077.122.077.743,0,1.5,0,2.226,0q.953,0,1.906,0a.337.337,0,0,1,.337.2c.2.4.409.813.61,1.208l.157.309.238.471c.2.4.407.805.616,1.2a1.162,1.162,0,0,0,1.053.622,1.409,1.409,0,0,0,.141-.007,1.171,1.171,0,0,0,.988-.845A1.306,1.306,0,0,0,1164.2,395.377Z",
    transform: "translate(-1151.062 -381.383)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M1152.765,382.8a1.618,1.618,0,1,0-1.611-1.616A1.63,1.63,0,0,0,1152.765,382.8Z",
    transform: "translate(-1150.86 -376.518)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M1165.377,377.694a10.2,10.2,0,0,1,.382-2.421A4.7,4.7,0,0,0,1165.5,372a1.465,1.465,0,0,0-.085-.134,7.489,7.489,0,0,1-.387,2.565,10.51,10.51,0,0,0-.389,1.7,3.255,3.255,0,0,0,.881,2.8A3.824,3.824,0,0,1,1165.377,377.694Z",
    transform: "translate(-1158.992 -371.866)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M1172.2,381.9c-.046-.32-.1-.584-.117-.851a7.614,7.614,0,0,1,.27-2.4,5.7,5.7,0,0,0,.212-2.559,4.425,4.425,0,0,0-.405-1.215c-.015.019-.026.026-.027.034,0,.038,0,.077,0,.115a7.436,7.436,0,0,1-.326,2.1,16.109,16.109,0,0,0-.444,1.773,3.344,3.344,0,0,0,.382,2.346C1171.866,381.459,1172.026,381.659,1172.2,381.9Z",
    transform: "translate(-1163.035 -373.685)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M1154.962,404.3h1.155v-1.1h-1.155Z",
    transform: "translate(-1153.162 -390.812)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M1150.41,403.754a.547.547,0,0,0,.6.546h.333v-1.1H1151A.55.55,0,0,0,1150.41,403.754Z",
    transform: "translate(-1150.41 -390.812)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M1165.2,404.3h1.154v-1.1H1165.2Z",
    transform: "translate(-1159.352 -390.812)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M1170.708,403.2c-.13-.006-.261-.007-.391-.006v1.095l.339,0a.755.755,0,0,0,.382-.12.518.518,0,0,0,.185-.579A.541.541,0,0,0,1170.708,403.2Z",
    transform: "translate(-1162.446 -390.81)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M1160.08,404.3h1.154v-1.1h-1.154Z",
    transform: "translate(-1156.257 -390.812)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaunaRoom);
export default __webpack_public_path__ + "static/media/saunaRoom.c017264716333ede2f943d7f3363bd61.svg";
export { ForwardRef as ReactComponent };